// Bane 1: Første vind (2026). En blid introduktion i Vestjylland.
// Nyt: træk en ledning, opgradér, send en montør, og se den første storm komme.
// Mørkeuret står stille indtil første årsskifte, så banen kan ikke tabes i de første 60 s.

import type { LevelDef } from '../../sim/types';

export const LEVEL_01: LevelDef = {
  id: '01-foerste-vind',
  number: 1,
  title: 'Første vind',
  year: 2026,
  intro: 'Holstebro sidder i mørket, og møllerne ved Idomlund snurrer for ingenting. Træk en ledning og tænd byen.',
  view: [0, 80, 125, 200],
  greenGoalPct: 50,
  sites: [
    { node: 'idomlund', kind: 'wind', name: 'Idomlund Vind', capMw: 600, fee: 4 },
    { node: 'holstebro', kind: 'city', tier: 1, maxTier: 3 },
    { node: 'nordjyllandsvaerket', kind: 'plant', name: 'Nordjyllandsværket', capMw: 720 },
    { node: 'struer', kind: 'city', tier: 0, maxTier: 2, at: [8, 15] },
    // Kunder i køen, i den rækkefølge de dukker op.
    { node: 'hjerm', kind: 'solar', name: 'Solpark Hjerm', capMw: 200, at: 'pool' },
    { node: 'lemvig', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
    { node: 'hovsoere', kind: 'wind', name: 'Høvsøre Vind', capMw: 250, at: 'pool' },
    { node: 'vinderup', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
    { node: 'skive', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    { node: 'nissum', kind: 'wind', name: 'Nissum Bredning Vind', capMw: 250, at: 'pool' },
    { node: 'herning', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    { node: 'bovling', kind: 'wind', name: 'Bøvlingbjerg Vind', capMw: 250, at: 'pool' },
    // Thyborøn og Videbæk ligger for enden af hver sin nye gren, mod nordvest og mod syd.
    { node: 'thyboron', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
    { node: 'videbaek', kind: 'wind', name: 'Videbæk Vind', capMw: 250, at: 'pool' },
  ],
  lines: [],
  mechanics: ['air', 'upgrade', 'double', 'crew', 'reinforce', 'station'],
  eventMenu: ['storm'],
  // Ét nyt i hvert år: første år bygger man bare, så kommer stormen (øvelsen), naboerne, elbilerne og
  // varmen. De tre sidste er gæster (events.ts guestKinds): én gang i deres år og én gang i finalen.
  // Spor "sværhed": som fast menu gjorde de bane 1 sværere end bane 3 på de hårde niveauer.
  news: [[], ['storm'], ['protest'], ['spike'], ['heatwave']],
  scripted: [
    // Den første storm rammer sporet over Struer, men ikke ledningen fra Idomlund til Holstebro.
    // Den kommer midt i andet år, efter Vinderup: rækkefølgen er byg, orange, opgradér og så storm.
    { kind: 'storm', at: [95, 105], warnS: 8, strength: 1, trackY: 150, trackHalf: 6, tutorial: true },
    // Finalen: en mild storm fra vest.
    { kind: 'storm', at: 12, warnS: 10, strength: 1, finale: true },
  ],
  growth: [{ node: 'holstebro', at: [18, 22], tier: 2 }],
  boosts: [],
  years: 5,
  finaleS: 40,
  clockFrozenUntilYear: 1,
  startCrews: 1,
  crewHome: 'holstebro',
  packs: [
    ['free_air3', 'two_crews'],
    ['free_double', 'free_air3'],
    ['two_crews', 'free_double'],
    ['free_air3', 'free_double'],
    ['free_station', 'free_air3'],
  ],
};
